<template>
  <w-external :state="state" :heading="txtHeading" :details="txtDetails">
  </w-external>
</template>

<script>
import i18n from '../i18n';
import External from './External';

export default {
  components: {
    'w-external': External,
  },
  props: ['state'],
  computed: {
    isBooking: function () {
      return this.state.booking.ref_num !== null;
    },
    txtHeading: function () {
      if (this.isBooking) {
        return i18n.gettext('We are looking forward to hosting you!');
      } else {
        return i18n.gettext(
          'You are still on our waitlist! We will contact you in case a table becomes available.'
        );
      }
    },
    txtDetails: function () {
      if (this.isBooking) {
        return i18n.gettext('Your booking details:');
      } else {
        return i18n.gettext('Your booking request details:');
      }
    },
  },
};
</script>
